import React from 'react'
import { useSearchConditionPc } from '../hooks/useSearchCondition'
import { SelectProps } from 'antd'
import { FilterSelectPc } from '../FilterSelect/FilterSelectPc'

export interface AccountStatusProps extends SelectProps {

}
const FilterAccountStatusPc = (props:AccountStatusProps) => {
    
    const { value, placeholder = '账号状态', ...rest } = props
    const { searchCondition, loading, getInitData } =  useSearchConditionPc({ client: ['new_status'] })

    return (
        <FilterSelectPc
            allowClear
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            style={{ width: '100%' }}
            mode='multiple'
            value={value}
            loading={loading}
            onFocus={getInitData}
            placeholder={placeholder}
            options={searchCondition.client?.new_status}
            {...rest}
        />
        
    )
}

export default FilterAccountStatusPc